import { ActionType, getType } from 'typesafe-actions';
import * as actions from '@actions/tabs-access';
import { ResultState } from '@rootCommon/types/common';
import { PermissionsUserAccessResponse } from '@rootCommon/types/permission-access';

type Action = ActionType<typeof actions>;

export type TabAccessState = ResultState<PermissionsUserAccessResponse | null>;

const initialState: TabAccessState = {
  data: null,
  loading: false,
  error: null,
};

const tabsAccessReducer = (state: TabAccessState = initialState, action: Action): TabAccessState => {
  switch (action.type) {
    case getType(actions.getAdminTabsAccess.request):
      return { ...state, loading: true, error: null };
    case getType(actions.getAdminTabsAccess.success):
      return { ...state, loading: false, data: action.payload };
    case getType(actions.getAdminTabsAccess.failure):
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default tabsAccessReducer;
